import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Tag, Select, Tooltip, Pagination } from "antd";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { loadingClient } from "../../../services";
import { changeDocumentTitle } from "../../../utils/title";

function LoadingClient() {

  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState(null)
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "_id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Load Number",
      dataIndex: "container_id",
      key: "LoadNumber",
    },
    {
      title: "Booking Number",
      dataIndex: "c_booking_number",
      key: "BookingNumber",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "Location",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Tag color={record?.is_client_approved_loadplan === 0 && record?.reject === 0 ? "yellow" :
          record?.reject === 1 ? "red" :
            "green"}>
          {record?.is_client_approved_loadplan === 0 && record?.reject === 0 ? "Pending" :
            record?.reject === 1 ? "Rejected" :
              "Approved"
          }
        </Tag>
      )
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record, { _id }) => (
        <Link to={`/operations/loadings/clients/views/${record.container_id}`} className="hover:text-primary">
          <Tooltip title='View'>
            {/* <Button type="primary" size="small"> */}
            <EyeOutlined />
            {/* </Button> */}
          </Tooltip>
        </Link>
      ),
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.current) => {
    try {
      setLoading(true);
      const { success, data, message } = await loadingClient.fetch(page, pageSize);
      if (success) {
        if (data && data.data && data.data.length > 0) {
          setClients(data.data);
          setPagination((prev) => ({
            ...prev,
            total: data.total,
            current: page,
            pageSize,
          }));
        } else {
          console.warn("No loading plan data found.");
          setClients([]);
        }
      } else {
        console.error(
          `Error: ${message || "Failed to fetch loading plan data."}`
        );
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle("Client Requests");
    initialize(pagination.current, pagination.pageSize);
  }, []);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Client Load Plans
        </h1>
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={clients}
        style={{ marginTop: "10px" }}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        //   showSizeChanger: false,
        // }}
        pagination={false}
        loading={loading}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
export default LoadingClient;
